'use strict';

var app = angular.module('directives.script', []);
app.directive('script', ['$compile', 'Storage', clickOutside]);

function clickOutside($compile, Storage) {
    return {
        restrict: 'E',
        scope: {
            lang: '@ngLang'
        },
        link: function($scope, element, attr) {
            if (attr.ngSrc) {
                $scope.lang = Storage.getItem('lang')=='ua' ? 'uk' : 'en';

                var domElem = '<script id="captchaSrc" src="'+attr.ngSrc+'&hl='+$scope.lang+'" async defer></script>';
                element.append($compile(domElem)($scope));
            }

        }
    }
}

module.exports = 'directives.script';



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/script-lang/index.js
 ** module id = 216
 ** module chunks = 1
 **/